/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".demo[_ngcontent-%COMP%]{padding:10px 0 7px;background-color:#c0f0ff;font-size:.95em;text-align:center}"];
export { styles as styles };
